<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             title="部件定损"
             @open="open"
             @closed="closed"
             width="900px"
             append-to-body>
    <div style="display: flex">
      <div style="flex-grow: 1"></div>
      <el-tag v-if="isAddParts" v-show="repairType === 'QUICK'" effect="light" style="border-radius: 10px">快修</el-tag>
      <el-radio-group v-else v-model="repairType_" style="margin: 20px 36px 20px">
        <el-radio label="COMMON">普通</el-radio>
        <el-radio label="QUICK">快修</el-radio>
      </el-radio-group>
    </div>
    <el-tabs v-loading="loading" tab-position="left" v-model="curPosition" style="height: 100%">
      <el-tab-pane v-for="item in partsTypes" :label="item.name" :name="item.code" :key="item.code">
        <parts-table :parts-list="partsMapByType[item.code] || []" :repair-type="repairType_"
                     :work="work"></parts-table>
      </el-tab-pane>
    </el-tabs>
    <template #footer>
      <el-button type="primary" @click="confirm" :loading="loading">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

  import PartsTable from '@/views/kanban/dialog/add-check/PartsTable'

  export default {
    name: 'LossDetermDialog',
    components: { PartsTable },
    props: {
      selectedPartsList: {
        type: Array,
        required: true
      },
      repairType: {
        type: String,
        required: true
      },
      isAddParts: {
        type: Boolean,
        required: true
      },
      work: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        loading: false,
        curPosition: null,
        partsMapByType: {},
        repairType_: null
      }
    },
    methods: {
      open () {
        this.loading = true
        this.repairType_ = this.repairType
      },
      closed () {
        this.curPosition = null
        this.partsMapByType = {}
      },
      cancel () {
        this.$emit('update:visible', false)
      },
      confirm () {
        const partsList = this.getNewPartsList()
        if (!partsList) return

        this.$emit('update:selectedPartsList', {
          repairType: this.repairType_,
          partsList
        })
        this.$emit('update:visible', false)
      },
      getNewPartsList () {
        const retData = []
        for (const type in this.partsMapByType) {
          const partsList = this.partsMapByType[type]
          for (const parts of partsList) {
            if (!this.quick) {
              if (!parts.selected) continue
              if (!parts.isDisassembly && !parts.isSheetMetal && !parts.isPaint) {
                this.$message.warning('请选择【' + parts.name + '】的维修类型！')
                return
              }
              if (parts.isSheetMetal && !parts.sheetMetalDegree) {
                this.$message.warning('请选择【' + parts.name + '】的钣金损伤程度！')
                return
              }
              if (parts.isPaint && !parts.paintDegree) {
                this.$message.warning('请选择【' + parts.name + '】的喷漆损伤程度！')
                return
              }
              const newItem = {
                id: parts.id,
                name: parts.name,
                isDisassembly: parts.isDisassembly,
                isSheetMetal: parts.isSheetMetal,
                isPaint: parts.isPaint,
                disassemblyWH: parts.isDisassembly ? parts.disassemblyWH : 0,
                sheetMetalWH: parts.isSheetMetal ? parts.sheetMetalWH : 0,
                assemblyWH: parts.isSheetMetal ? parts.assemblyWH : 0,
                paintArea: parts.isPaint ? parts.paintArea : 0,
                sheetMetalDegree: parts.isSheetMetal ? parts.sheetMetalDegree : null,
                paintDegree: parts.isPaint ? parts.paintDegree : null
              }
              if (this.isAddParts) {
                newItem.fixed = parts.fixed
              }
              retData.push(newItem)
            } else {
              if (!parts.isPaint) continue

              retData.push({
                id: parts.id,
                name: parts.name,
                isDisassembly: false,
                isSheetMetal: false,
                isPaint: true,
                disassemblyWH: 0,
                sheetMetalWH: 0,
                assemblyWH: 0,
                paintArea: parts.paintArea,
                sheetMetalDegree: null,
                paintDegree: null
              })
            }
          }
        }
        return retData
      }
    },
    computed: {
      selectedPartsMap () {
        const data = {}
        for (const parts of this.selectedPartsList) {
          data[parts.id] = parts
        }
        return data
      },
      quick () {
        return this.repairType_ === 'QUICK'
      },
      partsTypes () {
        return this.$store.state.data.PARTS_TYPE
      },
      partsList () {
        return this.$store.state.data.Parts
      },
      change () {
        return {
          selectedPartsList: this.selectedPartsList,
          partsTypes: this.partsTypes,
          partsList: this.partsList,
          loading: this.loading
        }
      }
    },
    watch: {
      change ({ selectedPartsList, partsTypes, partsList }) {
        if (!partsTypes || partsTypes.length === 0) return
        if (!partsList) return

        this.curPosition = this.partsTypes[0].code

        this.partsMapByType = {}

        for (const type of partsTypes) {
          const list = this.partsMapByType[type.code] = []
          list.splice(0, list.length)
          for (const parts of partsList) {
            if (parts.typeCode !== type.code) continue

            // 过滤品牌
            if (parts.brandIds && parts.brandIds.length > 0) {
              if (parts.brandIds.indexOf(this.work.brandModel[0]) === -1) {
                continue
              }
            }

            const selectedPart = this.selectedPartsMap[parts.id]
            const listItem = {
              id: parts.id,
              name: parts.name,
              fixed: selectedPart ? selectedPart.fixed : false,
              sheetMetalDegree: selectedPart ? selectedPart.sheetMetalDegree : null,
              paintDegree: selectedPart ? selectedPart.paintDegree : null,
              isDisassembly: selectedPart ? selectedPart.isDisassembly : false,
              isSheetMetal: selectedPart ? selectedPart.isSheetMetal : false,
              isPaint: selectedPart ? selectedPart.isPaint : false,
              disassemblyWH: selectedPart ? selectedPart.disassemblyWH : 0,
              sheetMetalWH: selectedPart ? selectedPart.sheetMetalWH : 0,
              paintArea: selectedPart ? selectedPart.paintArea : 0,
              assemblyWH: selectedPart ? selectedPart.assemblyWH : 0
            }
            listItem.selected = listItem.isDisassembly || listItem.isSheetMetal || listItem.isPaint
            list.push(listItem)
          }
        }

        console.log(this.partsMapByType)
        this.$store.dispatch('partsCoe/all').finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>
